import Vue from 'vue'
import store from '@/store'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'
import FeedbackSubmitter from '@/views/FeedbackSubmitter.vue'
import FeedbackRequestCreator from '@/views/FeedbackRequestCreator.vue'
import FeedbackResults from '@/views/FeedbackResults.vue'
import FeedbackResultsList from '@/views/FeedbackResultsList.vue'
import Login from '@/views/Login.vue'
import firebase from 'firebase'
import NotFoundPage from '@/views/NotFoundPage.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      showNavButton: true,
      allowAnonymous: true,
      title: 'Home'
    }
  },
  {
    path: '/Login',
    name: 'login',
    component: Login,
    meta: {
      showNavButton: true,
      allowAnonymous: true,
      title: 'Login'
    }
  },
  {
    path: '/error',
    name: 'error',
    component: NotFoundPage,
    meta: {
      showNavButton: true,
      allowAnonymous: true,
      title: 'Not Found'
    }
  },
  {
    path: '/submitfeedback/:feedbackRequestSharedId',
    name: 'submitfeedback',
    // route level code-splitting
    // this generates a separate chunk (submitfeedback.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: FeedbackSubmitter,
    meta: {
      showNavButton: true,
      allowAnonymous: true,
      title: 'Submit Feedback'
    }
  },
  {
    path: '/requestfeedback',
    name: 'requestfeedback',
    component: FeedbackRequestCreator,
    meta: {
      showNavButton: true,
      allowAnonymous: true,
      title: 'Create feedback request'
    }
  },
  {
    path: '/feedbackresults/:feedbackRequestId',
    name: 'feedbackresults',
    component: FeedbackResults,
    meta: {
      showNavButton: true,
      allowAnonymous: true,
      title: 'Feedback Results'
    }
  },
  {
    path: '/feedbackresults',
    name: 'feedbackresultslist',
    component: FeedbackResultsList,
    meta: {
      showNavButton: true,
      allowAnonymous: false,
      title: 'Feedback Results List'
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(record => !record.meta.allowAnonymous)
  const currentUser = await (firebase as any).getCurrentUser()
  if (requiresAuth && !currentUser) {
    store.state.targetRedirectUrl = to.path
    next('login')
  } else {
    setTimeout(() => next(), 0)
  }
})

export default router
